/* Component for the image on the basket product tiles  */

import styles from "./TileImage.module.scss";
import Image from "next/image";
import SrcsetPLP from "@/components/common/SrcsetPLP";
import ProductTagComp from "@/components/ProductTagComp";
import { useSelector,useDispatch } from "react-redux";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import { useDPIScreenCheck } from "@/hooks/useDPIScreenCheck";
import { makeId } from "@/helpers/userHelpers";

export default function TileImage({ url,href,badge_curated,donationProduct }) {
  const myLoader = ({ src, width, height, quality }) => {
    return `${src}?w=${width}&h=${height}&q=${quality || 75}`;
  };
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const dispatch = useDispatch();
  const isHighDPIScreen = useDPIScreenCheck() ? 2 : 1;
  let randomId = makeId(3);
  const handleClick = (e) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }
  }
  return (
    <>
      <a tabIndex={-1} href={href} onClick={(e) => handleClick(e)}>
      <div className={`${styles.image_container}`}>
      <ProductTagComp cname="tile_badge xxx-small" cvalue={badge_curated}/>
        {/* <Image
          id="#BasketImage"
          loader={myLoader}
          src={url}
          alt="beauty"
          layout=""
          height="120"
          width="95"
        /> */}
        <SrcsetPLP width={140} height={178} src={url} alt={url} loader={myLoader} id={`BasketImage-${randomId}`} className={`${donationProduct ? `${styles.updateCursor}` : ""} auto-basketId`} isHighDpi={isHighDPIScreen} tabIndex={0} />
      </div>
      </a>
    </>
  );
}
